var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"about-view"}},[_c('app-header'),_vm._v(" Feathers GUI is an interface to view and modify data records similar to the one available for Google Firebase or Firestore. "),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }